import React from 'react';
import { Card } from '@usealloy/component-library';

import TagsList from '~/entities/evaluations/TagsList';

import { useEventTypeEvaluationsContext } from '../context';

const Tags: React.FC = () => {
  const { evaluation } = useEventTypeEvaluationsContext();

  return (
    <Card
      header="Tags"
      collapsible
    >
      <TagsList
        tags={(evaluation.tags || []).filter(t => !t.is_outcome_reason)}
        outcome={evaluation.outcome}
        evaluationTags={evaluation.tags ?? []}
        evaluationToken={evaluation.evaluation_token}
        entityToken={evaluation.entity_token}
        workflowToken={evaluation.application_token}
        workflowVersion={evaluation.public_version}
      />
    </Card>
  );
};

export default Tags;
